import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { VERIFY_EMAIL_LINK_API } from '../../../constants/central-api';
import { applicationJSONBodyBuilder } from '../../../utils/body-builder';

export default async function verify_email_link_api_call(
  channelId: string,
  token: string
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const sellerToken = accessToken?.sellerToken;

  const requestInfo: RequestInfo = {
    url: VERIFY_EMAIL_LINK_API,
    method: 'POST',
    body: applicationJSONBodyBuilder({
      channel_id: channelId,
      token: token,
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'VERIFY_EMAIL_LINK';
  const customMsg = 'Email verified successfully!';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;

  if (res && res.actionType === actionType) {
    return response;
  } else {
    return null;
  }
}
